export default {
    /**
     * @description api请求基础路径
     */
    baseUrl: {
        dev: 'https://floriplant-apiv2.brightenkm.com',
        pro: 'https://apiv2.brighten-floriplant.cn',
    },

    fileServerUrl: {
        dev: 'https://img.brighten-floriplant.cn',
        pro: 'https://img.brighten-floriplant.cn'

    }
    ,
    downLoadFileUrl: {
        dev: 'https://floriplant-apiv2.brightenkm.com/storage',
        pro: 'http://oss.brighten-floriplant.cn'
    },
    devEnvironment: true //测试环境标识
};



// WEBPACK FOOTER //
// ./src/config/index.js